import React from "react";
import { PortalNewDevicesTemplate } from "themes/administration/analytics/components";

function PortalNewDevices(props) {
    return <PortalNewDevicesTemplate {...props} />;
}

export default PortalNewDevices;